/**
 * @generated SignedSource<<f1be512eefa5f4344ff7af795f9db259>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type goalTitleMetadata_AtlassianSearchPage$data = {
  readonly goal: {
    readonly status: {
      readonly localizedLabel: {
        readonly messageId: string | null | undefined;
      } | null | undefined;
      readonly score: number | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly targetDate: {
      readonly label: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "goalTitleMetadata_AtlassianSearchPage";
};
export type goalTitleMetadata_AtlassianSearchPage$key = {
  readonly " $data"?: goalTitleMetadata_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"goalTitleMetadata_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goalTitleMetadata_AtlassianSearchPage",
  "selections": [
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareLocalizationField",
              "kind": "LinkedField",
              "name": "localizedLabel",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "messageId"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "score"
            }
          ]
        },
        {
          "concreteType": "TownsquareTargetDate",
          "kind": "LinkedField",
          "name": "targetDate",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "label"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultAtlasGoal"
};

(node as any).hash = "c30318c731fc2ff06bbb542cb5aa234a";

export default node;
